
import { Inventory } from '../hoardings/inventory';

export class ConflictGroups {
    inventoryGroups: Inventory[] = [];
    inventoryGroup: Inventory = new Inventory();
}
